export const getStatusBadgeElements = (
  status: string
): { backgroundColor: string; textColor: string } => {
  switch (status) {
    case "PENDING":
      return {
        backgroundColor: "bg-ground-yellow-100",
        textColor: "text-white",
      };
    case "FINISHED":
      return {
        backgroundColor: "bg-ground-green-100",
        textColor: "text-white",
      };
    default:
      return {
        backgroundColor: "bg-red-500",
        textColor: "text-white",
      };
  }
};
